<template>
  <div id="confirm-paper">
    <div class="confirm">
      <dl>
        <dt>■メールアドレス</dt>
        <dd>{{order.email}}</dd>

        <dt>■お名前</dt>
        <dd>{{order.name}}様</dd>

        <dt>■郵便番号</dt>
        <dd>{{order.zip}}</dd>

        <dt>■ご住所</dt>
        <dd>
          {{order.address}}<br>
          {{order.street}}<br>
        </dd>

        <dt>■電話番号</dt>
        <dd>{{order.tel}}</dd>

        <dt>■決済方法</dt>
        <dd v-if="order.payment_method==='credit'">クレジットカード決済</dd>
        <dd v-if="order.payment_method==='bank'">銀行振込</dd>

        <dt>■備考</dt>
        <dd><span v-if="order.comment">{{order.comment}}</span><span v-else>なし</span></dd>

        <dt>■ご注文内容</dt>
        <dd v-if="stockCart && stockCart.length">
          <Preview :cart="cart" v-for="cart in stockCart" />

          <div class="price_table">
            <div class="subtotal">合計 {{ cartStockTotalPrice | currency }}.-</div>
            <div class="consumption">消費税(10%) {{ Math.ceil(cartStockTotalPrice * 0.1) | currency }}.-</div>
            <div class="total">総計 {{ cartStockTotalPrice + Math.ceil(cartStockTotalPrice * 0.1) | currency }}.-</div>
            <div class="annotation">
              ※送料が別途700円(税込)かかります。購入金額が20,000円(税抜)以上の場合送料は無料となります。<br>
              ※シミュレータ上の色は、画面の発色の特性上、実物に出来上がる色とは異なる場合ありますのでご了承願います。<br>
              ※商品の出来上がりまでの期間は１ヶ月〜１ヶ月半となっております。<br>
              ※注文後のキャンセルは出来ません。また、イメージと違った・サイズが合わない等でのクレーム・交換も受け付けられませんので、ご了承ください。
            </div>
          </div>
        </dd>
        <dd v-else><!-- カート機能が導入される以前のオーダー表示のために残してある -->
          <div class="preview_container">
            <div class="preview_front">
              <part v-for="part in preview_cart.parts" :key="part.id" :part="part" :reverse="0"></part>
              <letter v-for="letter in preview_cart.letters" :key="letter.id" :letter="letter" :reverse="0"></letter>
            </div>
            <div class="preview_back">
              <part v-for="part in preview_cart.parts" :key="part.id" :part="part" :reverse="1"></part>
              <letter v-for="letter in preview_cart.letters" :key="letter.id"  :letter="letter" :reverse="1"></letter>
            </div>
          </div>

          <div class="price_table">
            <div>
              ▪{{category_name | stripTags}}
              <br>
              {{figure_name | stripTags}}
              /
              {{design_name | stripTags}}
              <div v-for="pack in cart.packs">
                {{pack.size_name}} {{ designPrice | currency }} x {{pack.value}}
                {{ designPrice * pack.value | currency }}.-(税抜) <br>
                <span v-show="pack.number">#{{pack.number}} {{pack.name | stripTags}}</span>
              </div>
            </div>
            <br>
            <div>
              ▪カラー
              <br>
              <div v-for="part in cart.parts" class="column_3">
                <div>{{part.label}}</div>
                <div v-if="selected_part_color(part)">{{ selected_part_color(part).name }}</div>
                <div v-if="selected_part_color(part) && selected_part_color(part).price">
                  {{ selected_part_color(part).price | currency }}
                </div>
              </div>
            </div>
            <br>
            <div v-if="cart_letters.length">
              ▪文字
              <br>
              <div v-for="letter in cart_letters" class="column_3">
                <div v-if="letter.decoration">{{ letter.name }}</div>

                <div v-if="letter.decoration">
                  {{ letter.font.name }} / {{ selected_letter_color(letter).name }}
                </div>

                <div v-if="letter.decoration && letter.decoration.price">
                  <span>{{ letter.decoration.price | currency }}</span>
                  <br>
                  <span v-if="letter.decoration.color.price">(+{{ letter.decoration.color.price | currency }})</span>
                </div>
              </div>
            </div>
            <div class="subtotal">合計 {{ totalPrice() | currency }}.-</div>
            <div class="consumption">消費税(10%) {{ Math.ceil(totalPrice() * 0.1) | currency }}.-</div>
            <div class="total">総計 {{ totalPrice() + Math.ceil(totalPrice() * 0.1) | currency }}.-</div>
            <div class="annotation">
              ※送料が別途700円(税込)かかります。購入金額が20,000円(税抜)以上の場合送料は無料となります。<br>
              ※シミュレータ上の色は、画面の発色の特性上、実物に出来上がる色とは異なる場合ありますのでご了承願います。<br>
              ※商品の出来上がりまでの期間は１ヶ月〜１ヶ月半となっております。<br>
              ※注文後のキャンセルは出来ません。また、イメージと違った・サイズが合わない等でのクレーム・交換も受け付けられませんので、ご了承ください。
            </div>
          </div>
        </dd>
      </dl>
    </div>

    <slot></slot>

  </div>
</template>

<script>
  import Preview from './confirmPaper/Preview.vue'
  import {mapGetters} from 'vuex'

  export default {
    name: 'confirm-paper',
    components: {Preview},
    data(){
      return {
      }
    },
    created() {
      // console.log(this.stock_cart);
      // console.log(this.$store.state.cart);
    },
    methods: {
      selected_part_color(part){
        return part.designs_part.color;
      },
      selected_letter_color(letter){
        if (!letter.decoration){
          return;
        }
        return letter.decoration.color;
      }
    },
    computed: {
      ...mapGetters([
        'cart',
        'stockCart',
        'order',
        'designPrice',
        'basePrice',
        'totalPrice',
        'cartStockTotalPrice',
        'cartStockDesignPrice'
      ]),
      preview_cart() {
        return this.$store.state.cart;
      },
      category_name(){
        if (this.cart.category){
          return this.cart.category.name;
        }
      },
      figure_name(){
        if (this.cart.figure){
          return this.cart.figure.name;
        }
      },
      design_name(){
        if (this.cart.design){
          return this.cart.design.name;
        }
      },
      cart_letters() {
        return this.cart.letters.filter(letter => {
          if (!letter.decoration) return false;
          return letter.decoration.color_id !== null;
        });
      }
    },
  }
</script>

<style scoped>

  .confirm {
    padding: 5px;
  }
  .footer {
    padding: 5px;
    color: #fff;
    background-color: #151d66;
  }

  dd{
    margin-bottom: 1rem;
  }
  .subtotal, .consumption, .total{
    text-align: right;
  }
  .annotation{
    font-size:small;
  }

  .price_table{
    clear:both;
  }

  .picture {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    width: 100px;
    height: 80px;
  }

  .column_3 > div:nth-child(1){
    float: left;
    width:30%;
  }
  .column_3 > div:nth-child(2){
    float: left;
    width:55%;
  }
  .column_3 > div:nth-child(3){
    float: left;
    width:15%;
    text-align: right;
  }
  .column_3:after{
    content: "";
    clear: both;
    height: 0;
    display: block;
    visibility: hidden;
  }
</style>
